import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Checkbox, DialogContent, FormControlLabel } from '@mui/material';
import { DateTime } from 'luxon';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DatePickerComponent } from 'ui/DatePickerComponent';
import { addScheduleTerminationRequest } from 'redux/reducers/emManagement/reducer';
import { TSpecialRegistrationItem } from 'redux/reducers/emManagement/types';

type TTerminateDialogProps = {
	open: boolean;
	setClose: () => void;
	data: TSpecialRegistrationItem | null;
};

export const TerminateDialog: React.FC<TTerminateDialogProps> = ({ open, setClose, data }) => {
	const dispatch = useDispatch();
	const { emId } = useParams();
	const [removalDate, setRemovalDate] = React.useState<DateTime | null>(null);
	const [terminationCode3, setTerminationCode3] = React.useState(false);
	const [noNotification, setNoNotification] = React.useState(false);

	React.useEffect(() => {
		if (!open) {
			setRemovalDate(null);
			setTerminationCode3(false);
			setNoNotification(false);
		} else {
			setTerminationCode3(data?.terminationCode3 ?? false);
		}
	}, [open]);

	const handleSubmit = () => {
		if (!emId || !removalDate || !data?.specialSchemeType) return;
		dispatch(
			addScheduleTerminationRequest({
				emId: Number(emId),
				data: {
					specialSchemeType: data.specialSchemeType,
					removalDate: removalDate.toUTC().toISO({ suppressMilliseconds: false }) as string,
					emNonEuVatId: data.emNonEuVatId ?? 0,
					terminationCode3,
					noNotification,
				},
			}),
		);
		setClose();
	};

	return (
		<Dialog
			open={open}
			sx={{
				'& .MuiDialog-paper': { width: '420px', maxWidth: '420px', borderRadius: '12px' },
			}}
		>
			<DialogTitle color="primary">Schedule termination</DialogTitle>
			<DialogContent sx={{ p: '12px' }}>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
					<DatePickerComponent
						id="removalDate"
						label="Termination date"
						value={removalDate}
						onChange={(date) => setRemovalDate(date)}
					/>
					<FormControlLabel
						control={
							<Checkbox
								id="terminationCode3"
								checked={terminationCode3}
								onChange={(e) => setTerminationCode3(e.target.checked)}
							/>
						}
						label="Termination code 3"
					/>
					<FormControlLabel
						control={
							<Checkbox
								id="noNotification"
								checked={noNotification}
								onChange={(e) => setNoNotification(e.target.checked)}
							/>
						}
						label="No notification"
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleSubmit} variant="contained" disabled={!removalDate}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};
